"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Input = require("./Input.styles");

var _images = require("../../assets/images");

var _eye = _interopRequireDefault(require("../../assets/images/eye"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const isFunction = x => typeof x === 'function';

const Input = /*#__PURE__*/_react.default.forwardRef(({
  inputProps,
  errorProps,
  label,
  className: containerClassName,
  icon,
  isFloatedLabel = true,
  error,
  kind,
  errorMessage,
  width,
  prefix,
  suffix,
  maskOptions,
  showBorderWithFloatedLabel,
  ...containerPropsRest
}, ref) => {
  const [value, setValue] = (0, _react.useState)(inputProps.value || '');
  const [isControlled] = (0, _react.useState)(typeof inputProps.value === 'string');
  const [isFocused, setFocus] = (0, _react.useState)(false);
  const [showPass, setPass] = (0, _react.useState)(false);
  const inputRef = (0, _react.useRef)(ref || null);
  const [isAutofilled, setAutofill] = (0, _react.useState)(false);
  const setInputValue = (0, _react.useCallback)((value = '') => {
    setValue(value);
  }, []);
  (0, _react.useEffect)(() => {
    if (isControlled) {
      return setInputValue(inputProps.value);
    }

    setInputValue(inputProps.defaultValue);
  }, [inputProps.defaultValue, inputProps.value, isControlled, setInputValue]);
  (0, _react.useEffect)(() => {
    if (inputProps.value) {
      setInputValue(inputProps.value);
      setFocus(true);
    }

    prefix ? setFocus(true) : '';
  }, [inputProps.value, prefix, setInputValue]);
  (0, _react.useEffect)(() => {
    if (maskOptions && Object.keys(maskOptions).length > 0 && inputRef && inputRef.current) {
      Promise.resolve().then(() => _interopRequireWildcard(require('inputmask'))).then(module => {
        module.default(maskOptions).mask(inputRef.current);
      });
    }
  }, [inputRef, maskOptions]);
  (0, _react.useEffect)(() => {
    inputRef && inputRef.current && inputRef.current.addEventListener('animationstart', () => setAutofill(true), false);
  }, [inputRef]);

  const handleBlur = event => {
    !prefix && setFocus(false);
    if (!value.length && isAutofilled) setAutofill(false);

    if (isFunction(inputProps.onBlur)) {
      inputProps.onBlur(event);
    }
  };

  const handleFocus = event => {
    setFocus(true);

    if (isFunction(inputProps.onFocus)) {
      inputProps.onFocus(event);
    }
  };

  const handleChange = event => {
    if (!isControlled) {
      setInputValue(event.target.value);
    }

    if (isFunction(inputProps.onChange)) {
      inputProps.onChange(event);
    }
  };

  const handleKeyPress = event => {
    if (inputProps.type === 'number') {
      const keys = ['e', 'E'];

      if (keys.includes(event.key)) {
        event.preventDefault();
      }
    }

    if (isFunction(inputProps.onKeyPress)) {
      inputProps.onKeyPress(event);
    }
  };

  const {
    className: inputClassName,
    placeholder,
    boxed,
    type,
    ...inputPropsRest
  } = inputProps || {};
  const Icon = _images.icons[icon];
  return /*#__PURE__*/_react.default.createElement(_Input.StyledInputComponent, {
    className: containerClassName,
    width: width
  }, /*#__PURE__*/_react.default.createElement(_Input.StyledInputContainer, _extends({
    className: (0, _classnames.default)({
      container_error: error,
      container_focus: isFocused,
      [kind]: kind,
      boxed: boxed,
      filled: value.length > 0 || isAutofilled,
      ['icon-left']: icon,
      ['floated-label']: isFloatedLabel || prefix,
      disabled: inputProps.disabled,
      password: type === 'password'
    }),
    isFocused: isFocused,
    showBorderWithFloatedLabel: showBorderWithFloatedLabel
  }, containerPropsRest), /*#__PURE__*/_react.default.createElement("label", {
    className: "input__parent"
  }, label ? /*#__PURE__*/_react.default.createElement("span", {
    className: "input__label"
  }, label) :
  /*#__PURE__*/
  // Used for ADA compliance
  _react.default.createElement("span", {
    className: "input__label--hidden"
  }, placeholder), /*#__PURE__*/_react.default.createElement("div", {
    className: "input__wrapper"
  }, icon && /*#__PURE__*/_react.default.createElement("span", {
    className: "icon left"
  }, /*#__PURE__*/_react.default.createElement(Icon, null)), prefix && /*#__PURE__*/_react.default.createElement("span", {
    className: "icon left"
  }, prefix), /*#__PURE__*/_react.default.createElement(_Input.StyledInput, _extends({
    ref: inputRef,
    placeholder: placeholder,
    onBlur: handleBlur,
    onKeyPress: handleKeyPress,
    onFocus: handleFocus,
    onChange: handleChange,
    className: inputClassName,
    value: value,
    boxed: boxed,
    type: type === 'password' && showPass ? 'text' : type
  }, inputPropsRest)), suffix && /*#__PURE__*/_react.default.createElement("span", {
    className: "icon right"
  }, suffix), type === 'password' && value.length > 0 && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)({
      input__show: true,
      [`show-pass`]: showPass
    }),
    onClick: () => setPass(!showPass)
  }, /*#__PURE__*/_react.default.createElement(_eye.default, null))))), error && errorMessage && /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "error"
  }, errorProps), errorMessage));
});

exports.Input = Input;
Input.propTypes = {
  error: _propTypes.default.bool,
  errorMessage: _propTypes.default.string,
  label: _propTypes.default.string,
  icon: _propTypes.default.string,
  boxed: _propTypes.default.bool,
  className: _propTypes.default.string,
  inputProps: _propTypes.default.shape({
    defaultValue: _propTypes.default.string,
    onBlur: _propTypes.default.func,
    onFocus: _propTypes.default.func,
    onChange: _propTypes.default.func,
    onKeyPress: _propTypes.default.func,
    type: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    placeholder: _propTypes.default.string,
    disabled: _propTypes.default.bool
  }),
  errorProps: _propTypes.default.object,
  kind: _propTypes.default.string,
  isFloatedLabel: _propTypes.default.bool,

  /** width should be given with units like 100px */
  width: _propTypes.default.string,

  /** Prefix to show in input field */
  prefix: _propTypes.default.string,

  /** Suffix to show in input field */
  suffix: _propTypes.default.string,

  /** Mask Props object, accept mask as regex/patterns */
  maskOptions: _propTypes.default.shape({
    mask: _propTypes.default.string,
    placeholder: _propTypes.default.string,
    regex: _propTypes.default.string,
    alias: _propTypes.default.string,
    inputFormat: _propTypes.default.string
  }),
  showBorderWithFloatedLabel: _propTypes.default.bool
};
Input.defaultProps = {
  inputProps: {
    type: 'text'
  },
  showBorderWithFloatedLabel: true
};